// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select, { components } from "react-select";
import {
  Col,
  Button,
  Form,
  Row,
  Spinner,
  ButtonGroup,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import { multiSelectStyle } from "../../../styles/styles";
import ScrollMenu from "../../Scrolls/ScrollMenu";
import { sortingCarets } from "../utils";
import { GeneralError } from "../../Errors/GeneralError";
import {
  Portlet,
  PortletBody,
} from "../../../../components/GenericPortlet/Portlet";
import language from "../../../utils/en.json";

export function MfaRegistrationTable(props) {
  const {
    isError,
    isLoading: isParentLoading,
    tableData,
    onPageChange,
    onSizePerPageChange,
    sizePerPageList,
    keyField,
    showPagination,
    componentIsForPdf,
  } = props;

  const [isLoading, setLoading] = useState(true);
  const [filteredTableData, setFilteredTableData] = useState([]);

  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showUsernameMenu, setShowUsernameMenu] = useState(false);
  const [showRoleMenu, setShowRoleMenu] = useState(false);
  const [showLicenseTypeMenu, setShowLicenseTypeMenu] = useState(false);
  const [showGroupMenu, setShowGroupMenu] = useState(false);
  const [showMfaRegistrationMenu, setShowMfaRegistrationMenu] = useState(false);

  const userRef = useRef();
  const usernameRef = useRef();
  const roleRef = useRef();
  const licenseTypeRef = useRef();
  const groupRef = useRef();
  const mfaRegistrationRef = useRef();

  const [userOptions, setUserOptions] = useState([]);
  const [usernameOptions, setUsernameOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [licenseTypeOptions, setLicenseTypeOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [mfaRegistrationOptions, setMfaRegistrationOptions] = useState([]);

  const [userSelectedOptions, setUserSelectedOptions] = useState([]);
  const [usernameSelectedOptions, setUsernameSelectedOptions] = useState([]);
  const [roleSelectedOptions, setRoleSelectedOptions] = useState([]);
  const [licenseTypeSelectedOptions, setLicenseTypeSelectedOptions] = useState(
    []
  );
  const [groupSelectedOptions, setGroupSelectedOptions] = useState([]);
  const [mfaRegistrationSelectedOptions, setMfaRegistrationSelectedOptions] =
    useState([]);

  const [numPerPage, setNumPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const NullableLabel = language["NULLABLE.VALUES"]; // NullableValues

  // Handles setting the data list to be the correct filtered list
  useEffect(() => {
    if (tableData?.length) {
      const updatedFilteredData = filterTable(tableData);
      setFilteredTableData(updatedFilteredData);
    }
  }, [
    userSelectedOptions,
    usernameSelectedOptions,
    roleSelectedOptions,
    licenseTypeSelectedOptions,
    groupSelectedOptions,
    mfaRegistrationSelectedOptions,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (page) => {
    setCurrentPage(page);
    document.getElementById("mfaRegistrationTable").scrollIntoView();
  };

  const handleSizePerPageChange = (sizePerPage) => {
    setNumPerPage(sizePerPage);
    setCurrentPage(1);
    document.getElementById("mfaRegistrationTable").scrollIntoView();
  };

  const defaultSizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ];

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    formatRiskDetectionTableData();
    setFilteredTableData(tableData);
  }, [tableData]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatRiskDetectionTableData = async () => {
    setLoading(true);

    let userData = [];
    let usernameData = [];
    let roleData = [];
    let licenseTypeData = [];
    let groupData = [];
    let mfaRegistrationData = [];

    for (let i = 0; i < tableData?.length; i++) {
      const mfaRegistrationTableData = tableData[i];
      const userName = `${mfaRegistrationTableData?.firstName} ${mfaRegistrationTableData?.lastName}`;

      if (userName) {
        userData.push({ value: userName, label: userName });
      }

      if (mfaRegistrationTableData?.username) {
        usernameData.push({
          value: mfaRegistrationTableData.username,
          label: mfaRegistrationTableData.username,
        });
      }

      for (const role of mfaRegistrationTableData?.role) {
        roleData.push({ value: role, label: role });
      }
      for (const licenseType of mfaRegistrationTableData?.licenseType) {
        licenseTypeData.push({ value: licenseType, label: licenseType });
      }
      for (const group of mfaRegistrationTableData?.group) {
        groupData.push({ value: group, label: group });
      }

      if (mfaRegistrationTableData?.mfaRegistration !== undefined) {
        mfaRegistrationData.push({
          value: mfaRegistrationTableData?.mfaRegistration,
          label: mfaRegistrationTableData?.mfaRegistration ?? NullableLabel,
        });
      }
    }

    const userMap = new Map();
    for (const userObject of userData) {
      const currentUserCount = userMap.get(userObject.label);

      if (currentUserCount !== undefined) {
        userMap.set(userObject.label, currentUserCount + 1);
      } else {
        userMap.set(userObject.label, 1);
      }
    }
    for (const userObject of userData) {
      userObject.count = userMap.get(userObject.label);
    }

    const usernameMap = new Map();
    for (const usernameObject of usernameData) {
      const currentUsernameCount = usernameMap.get(usernameObject.label);

      if (currentUsernameCount !== undefined) {
        usernameMap.set(usernameObject.label, currentUsernameCount + 1);
      } else {
        usernameMap.set(usernameObject.label, 1);
      }
    }
    for (const usernameObject of usernameData) {
      usernameObject.count = usernameMap.get(usernameObject.label);
    }

    const roleMap = new Map();
    for (const roleObject of roleData) {
      const currentRoleCount = roleMap.get(roleObject.label);

      if (currentRoleCount !== undefined) {
        roleMap.set(roleObject.label, currentRoleCount + 1);
      } else {
        roleMap.set(roleObject.label, 1);
      }
    }
    for (const roleObject of roleData) {
      roleObject.count = roleMap.get(roleObject.label);
    }

    const licenseTypeMap = new Map();
    for (const licenseTypeObject of licenseTypeData) {
      const licenseTypeCount = licenseTypeMap.get(licenseTypeObject.label);

      if (licenseTypeCount !== undefined) {
        licenseTypeMap.set(licenseTypeObject.label, licenseTypeCount + 1);
      } else {
        licenseTypeMap.set(licenseTypeObject.label, 1);
      }
    }
    for (const licenseTypeObject of licenseTypeData) {
      licenseTypeObject.count = licenseTypeMap.get(licenseTypeObject.label);
    }

    const groupMap = new Map();
    for (const groupObject of groupData) {
      const groupCount = groupMap.get(groupObject.label);

      if (groupCount !== undefined) {
        groupMap.set(groupObject.label, groupCount + 1);
      } else {
        groupMap.set(groupObject.label, 1);
      }
    }
    for (const groupObject of groupData) {
      groupObject.count = groupMap.get(groupObject.label);
    }

    const mfaRegistrationMap = new Map();
    for (const mfaRegistrationObject of mfaRegistrationData) {
      const mfaRegistrationCount = mfaRegistrationMap.get(
        mfaRegistrationObject.label
      );

      if (mfaRegistrationCount !== undefined) {
        mfaRegistrationMap.set(
          mfaRegistrationObject.label,
          mfaRegistrationCount + 1
        );
      } else {
        mfaRegistrationMap.set(mfaRegistrationObject.label, 1);
      }
    }
    for (const mfaRegistrationObject of mfaRegistrationData) {
      mfaRegistrationObject.count = mfaRegistrationMap.get(
        mfaRegistrationObject.label
      );
    }

    setLoading(false);
  };

  const filterTable = (dataToFilter) => {
    const filterHelper = (field, filterOptions) => {
      if (filterOptions?.length) {
        dataToFilter = dataToFilter.filter((dataObject) =>
          filterOptions.some((option) => {
            if (field === "user") {
              return (
                `${dataObject.firstName} ${dataObject.lastName}` ===
                option.value
              );
            }

            return option.value === dataObject[`${field}`];
          })
        );
      }
    };

    // Filters for columns that contain options with array values
    const filterHelperArray = (field, filterOptions) => {
      if (filterOptions?.length) {
        dataToFilter = dataToFilter.filter((dataObject) =>
          filterOptions.some((filterOption) =>
            dataObject[field].some(
              (fieldString) => fieldString === filterOption.value
            )
          )
        );
      }
    };

    filterHelper("user", userSelectedOptions);
    filterHelper("username", usernameSelectedOptions);
    filterHelperArray("role", roleSelectedOptions);
    filterHelperArray("licenseType", licenseTypeSelectedOptions);
    filterHelperArray("group", groupSelectedOptions);
    filterHelper("mfaRegistration", mfaRegistrationSelectedOptions);
    return dataToFilter;
  };

  const updateFilter = (filterType, selectedFilterValueArray) => {
    switch (filterType) {
      case "user":
        if (selectedFilterValueArray?.length) {
          setUserSelectedOptions(selectedFilterValueArray);
        } else {
          setUserSelectedOptions([]);
        }
        break;
      case "username":
        if (selectedFilterValueArray?.length) {
          setUsernameSelectedOptions(selectedFilterValueArray);
        } else {
          setUsernameSelectedOptions([]);
        }
        break;
      case "role":
        if (selectedFilterValueArray?.length) {
          setRoleSelectedOptions(selectedFilterValueArray);
        } else {
          setRoleSelectedOptions([]);
        }
        break;
      case "licenseType":
        if (selectedFilterValueArray?.length) {
          setLicenseTypeSelectedOptions(selectedFilterValueArray);
        } else {
          setLicenseTypeSelectedOptions([]);
        }
        break;
      case "group":
        if (selectedFilterValueArray?.length) {
          setGroupSelectedOptions(selectedFilterValueArray);
        } else {
          setGroupSelectedOptions([]);
        }
        break;
      case "mfaRegistration":
        if (selectedFilterValueArray?.length) {
          setMfaRegistrationSelectedOptions(selectedFilterValueArray);
        } else {
          setMfaRegistrationSelectedOptions([]);
        }
        break;
      default:
        break;
    }
  };

  function ValueContainer({ children, getValue, ...props }) {
    const { length } = getValue();
    return (
      <components.ValueContainer {...props}>
        {length === 1 && (
          <>
            <span className="multi-select-value">
              {props.selectProps.value[0].label}
            </span>
            <ClearIndicator {...props} />
          </>
        )}
        {length > 1 && (
          <>
            <span className="multi-select-value">{length}</span>
            <ClearIndicator {...props} />
            <components.Placeholder {...props} className="multi-select-label">
              {props.selectProps.placeholder}
            </components.Placeholder>
          </>
        )}
      </components.ValueContainer>
    );
  }

  function ClearIndicator({ innerRef, children, ...props }) {
    const onClear = (e) => {
      if (props.selectProps?.name === "user") {
        updateFilter("user", undefined);
      }
      if (props.selectProps?.name === "username") {
        updateFilter("username", undefined);
      }
      if (props.selectProps?.name === "role") {
        updateFilter("role", undefined);
      }
      if (props.selectProps?.name === "licenseType") {
        updateFilter("licenseType", undefined);
      }
      if (props.selectProps?.name === "group") {
        updateFilter("group", undefined);
      }
      if (props.selectProps?.name === "mfaRegistration") {
        updateFilter("mfaRegistration", undefined);
      }

      e.stopPropagation();
      e.preventDefault();
    };

    return (
      <div ref={innerRef} className="multi-select-clear" onClick={onClear}>
        <components.ClearIndicator {...props}>
          <span className="icon-xs flaticon2-cross p-2" />
        </components.ClearIndicator>
      </div>
    );
  }

  function Option({ children, ...props }) {
    const { isSelected, label, value, isMulti, data } = props;

    const onClick = (e) => {
      props.selectOption({ ...data });
      e.stopPropagation();
      e.preventDefault();
    };

    if (isMulti) {
      return (
        <components.Option {...props}>
          <div className="multi-select-option" onClick={onClick}>
            <Form.Check
              custom
              readOnly
              className="multi-select-check"
              checked={isSelected}
              label={label}
              value={value}
            />
            <span className="multi-select-count">{props.data.count}</span>
          </div>
        </components.Option>
      );
    }
  }

  // Security Check: Click handler for multi-select menus (workaround)
  const handleClick = (target, event) => {
    if (target === "user") {
      if (showUserMenu) {
        setShowUserMenu(false);
        if (userRef.current.select.inputRef) {
          userRef.current.select.inputRef.blur();
        }
      } else {
        setShowUserMenu(true);
      }
    }
    if (target === "username") {
      if (showUsernameMenu) {
        setShowUsernameMenu(false);
        if (usernameRef.current.select.inputRef) {
          usernameRef.current.select.inputRef.blur();
        }
      } else {
        setShowUsernameMenu(true);
      }
    }
    if (target === "role") {
      if (showRoleMenu) {
        setShowRoleMenu(false);
        if (roleRef.current.select.inputRef) {
          roleRef.current.select.inputRef.blur();
        }
      } else {
        setShowRoleMenu(true);
      }
    }
    if (target === "licenseType") {
      if (showLicenseTypeMenu) {
        setShowLicenseTypeMenu(false);
        if (licenseTypeRef.current.select.inputRef) {
          licenseTypeRef.current.select.inputRef.blur();
        }
      } else {
        setShowLicenseTypeMenu(true);
      }
    }
    if (target === "group") {
      if (showGroupMenu) {
        setShowGroupMenu(false);
        if (groupRef.current.select.inputRef) {
          groupRef.current.select.inputRef.blur();
        }
      } else {
        setShowGroupMenu(true);
      }
    }
    if (target === "mfaRegistration") {
      if (showMfaRegistrationMenu) {
        setShowMfaRegistrationMenu(false);
        if (mfaRegistrationRef.current.select.inputRef) {
          mfaRegistrationRef.current.select.inputRef.blur();
        }
      } else {
        setShowMfaRegistrationMenu(true);
      }
    }
  };

  // Outside click handler for hiding multi-select menus (workaround due to closeMenuOnSelect being disabled)
  const handleClickOutside = (event) => {
    if (
      userRef.current &&
      !userRef.current.select.controlRef.contains(event.target) &&
      !userRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowUserMenu(false);
      if (userRef.current.select.inputRef) {
        userRef.current.select.inputRef.blur();
      }
    }
    if (
      usernameRef.current &&
      !usernameRef.current.select.controlRef.contains(event.target) &&
      !usernameRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowUsernameMenu(false);
      if (usernameRef.current.select.inputRef) {
        usernameRef.current.select.inputRef.blur();
      }
    }
    if (
      roleRef.current &&
      !roleRef.current.select.controlRef.contains(event.target) &&
      !roleRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowRoleMenu(false);
      if (roleRef.current.select.inputRef) {
        roleRef.current.select.inputRef.blur();
      }
    }
    if (
      licenseTypeRef.current &&
      !licenseTypeRef.current.select.controlRef.contains(event.target) &&
      !licenseTypeRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowLicenseTypeMenu(false);
      if (licenseTypeRef.current.select.inputRef) {
        licenseTypeRef.current.select.inputRef.blur();
      }
    }
    if (
      groupRef.current &&
      !groupRef.current.select.controlRef.contains(event.target) &&
      !groupRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowGroupMenu(false);
      if (groupRef.current.select.inputRef) {
        groupRef.current.select.inputRef.blur();
      }
    }
    if (
      mfaRegistrationRef.current &&
      !mfaRegistrationRef.current.select.controlRef.contains(event.target) &&
      !mfaRegistrationRef.current.select?.focusedOptionRef?.contains(
        event.target
      )
    ) {
      setShowMfaRegistrationMenu(false);
      if (mfaRegistrationRef.current.select.inputRef) {
        mfaRegistrationRef.current.select.inputRef.blur();
      }
    }
  };

  const formatArrayColumn = (row, rowType) => {
    if (componentIsForPdf) {
      const returnArray = [];
      for (let i = 0; i < row[rowType].length; i++) {
        returnArray.push(<div className="chip">{row[rowType][i]}</div>);

        if (i !== row[rowType].length - 1) {
          returnArray.push(<br />);
        }
      }
      return returnArray;
    }
    if (row && row[rowType]) {
      const returnArray = [];
      let collapsed = "";

      for (let i = 0; i < row[rowType].length; i++) {
        if (i < 2) {
          returnArray.push(
            <div key={i} className="chip">
              {row[rowType][i]}
            </div>
          );
        } else {
          collapsed += !collapsed.length
            ? row[rowType][i]
            : `, ${row[rowType][i]}`;
        }
      }

      const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          {collapsed}
        </Tooltip>
      );

      if (row[rowType].length > 2) {
        returnArray.push(
          <div key={2}>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <div className="chip"> +{row[rowType].length - 2} </div>
            </OverlayTrigger>
          </div>
        );
      }
      return returnArray;
    }
  };

  const formatUserColumn = (cell, row) => (
    <span>{`${row.firstName} ${row.lastName}`}</span>
  );
  const formatUsernameColumn = (cell, row) => <span>{row.username}</span>;
  const formatRoleColumn = (cell, row) => {
    if (!Array.isArray(row.role)) {
      row.role = [row.role];
    }
    return formatArrayColumn(row, "role");
  };
  const formatGroupColumn = (cell, row) => {
    if (!Array.isArray(row.group)) {
      row.group = [row.group];
    }
    return formatArrayColumn(row, "group");
  };
  const formatLicenseTypeColumn = (cell, row) => {
    if (!Array.isArray(row.licenseType)) {
      row.licenseType = [row.licenseType];
    }
    return formatArrayColumn(row, "licenseType");
  };

  const formatMfaRegistrationColumn = (cell, row) => {
    if (row?.mfaRegistration === null) {
      return <span>{NullableLabel}</span>;
    }

    return <span>{row?.mfaRegistration}</span>;
  };

  const formatPDFTableHeader = (text) => (
    <span className="tableHeaderPdf">{text}</span>
  );

  const formatUserHeader = () => {
    const text = "User";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div className="select-container" onClick={(e) => handleClick("user", e)}>
        <Select
          id="user"
          ref={userRef}
          autoBlur
          name="user"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showUserMenu}
          options={userOptions}
          value={userSelectedOptions}
          onChange={(value) => updateFilter("user", value)}
          placeholder="User"
          isClearable={false}
          isSearchable
          components={
            userSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatUsernameHeader = () => {
    const text = "Username";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("username", e)}
      >
        <Select
          id="username"
          ref={usernameRef}
          autoBlur
          name="username"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showUsernameMenu}
          options={usernameOptions}
          value={usernameSelectedOptions}
          onChange={(value) => updateFilter("username", value)}
          placeholder={text}
          isClearable={false}
          isSearchable
          components={
            usernameSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatRoleHeader = () => {
    const text = "Role";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div className="select-container" onClick={(e) => handleClick("role", e)}>
        <Select
          id="role"
          ref={roleRef}
          autoBlur
          name="role"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showRoleMenu}
          options={roleOptions}
          value={roleSelectedOptions}
          onChange={(value) => updateFilter("role", value)}
          placeholder={text}
          isClearable={false}
          isSearchable
          components={
            roleSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatLicenseTypeHeader = () => {
    const text = "License Type";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("licenseType", e)}
      >
        <Select
          id="licenseType"
          ref={licenseTypeRef}
          autoBlur
          name="licenseType"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showLicenseTypeMenu}
          options={licenseTypeOptions}
          value={licenseTypeSelectedOptions}
          onChange={(value) => updateFilter("licenseType", value)}
          placeholder={text}
          isClearable={false}
          isSearchable
          components={
            licenseTypeSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatGroupHeader = () => {
    const text = "Group";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("group", e)}
      >
        <Select
          id="group"
          ref={groupRef}
          autoBlur
          name="group"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showGroupMenu}
          options={groupOptions}
          value={groupSelectedOptions}
          onChange={(value) => updateFilter("group", value)}
          placeholder="Group"
          isClearable={false}
          isSearchable
          components={
            groupSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatMfaRegistrationHeader = () => {
    const text = "MFA Registration";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("mfaRegistration", e)}
      >
        <Select
          id="mfaRegistration"
          ref={mfaRegistrationRef}
          autoBlur
          name="mfaRegistration"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showMfaRegistrationMenu}
          options={mfaRegistrationOptions}
          value={mfaRegistrationSelectedOptions}
          onChange={(value) => updateFilter("mfaRegistration", value)}
          placeholder={text}
          isClearable={false}
          isSearchable
          components={
            mfaRegistrationSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const columns = [
    {
      dataField: "id",
      hidden: true,
    },
    {
      dataField: "user",
      text: "User",
      formatter: formatUserColumn,
      headerFormatter: formatUserHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "username",
      text: "Username",
      formatter: formatUsernameColumn,
      headerFormatter: formatUsernameHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "role",
      text: "Role",
      formatter: formatRoleColumn,
      headerFormatter: formatRoleHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "licenseType",
      text: "License Type",
      formatter: formatLicenseTypeColumn,
      headerFormatter: formatLicenseTypeHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "group",
      text: "Group",
      formatter: formatGroupColumn,
      headerFormatter: formatGroupHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "mfaRegistration",
      text: "MFA Registration",
      formatter: formatMfaRegistrationColumn,
      headerFormatter: formatMfaRegistrationHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
  ];

  return (
    <div id="mfaRegistrationTable">
      <Row>
        <Col sm="12" md="12" lg="12" xl="12">
          {isLoading || isParentLoading ? (
            <Portlet
              fluidHeight={false}
              className="portlet--border-bottom-dark"
            >
              <PortletBody fluid style={{ padding: 0 }}>
                <>
                  <Spinner />
                </>
              </PortletBody>
            </Portlet>
          ) : showPagination ? (
            <PaginationProvider
              pagination={paginationFactory({
                custom: true,
                page: currentPage,
                totalSize:
                  filteredTableData && filteredTableData.length
                    ? filteredTableData.length
                    : 0,
                sizePerPage: numPerPage,
                onPageChange: onPageChange || handlePageChange,
                onSizePerPageChange:
                  onSizePerPageChange || handleSizePerPageChange,
                sizePerPageList: sizePerPageList || defaultSizePerPageList,
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={filteredTableData}
                  columns={columns}
                >
                  {(props) => (
                    <Row>
                      <Col md="12">
                        <BootstrapTable
                          {...props.baseProps}
                          keyField={keyField}
                          loading={isLoading}
                          filter={filterFactory()}
                          bordered={false}
                          hover={!!(!isLoading && filteredTableData?.length)}
                          bootstrap4
                          sort={{
                            dataField: "name",
                            order: "asc",
                          }}
                          noDataIndication={
                            isError ? (
                              <GeneralError />
                            ) : isLoading ? (
                              <Spinner />
                            ) : (
                              <div className="no-data">
                                {language["GENERAL.NO_DATA"]}
                              </div>
                            )
                          }
                          {...paginationTableProps}
                        />
                        {filteredTableData?.length > 10 && (
                          <div className="pagination">
                            <div>
                              <ButtonGroup>
                                {paginationProps.sizePerPageList.map(
                                  (option) => (
                                    <Button
                                      key={option.text}
                                      onClick={() =>
                                        handleSizePerPageChange(option.value)
                                      }
                                      variant={
                                        numPerPage === option.value
                                          ? "primary"
                                          : "light"
                                      }
                                    >
                                      {option.text}
                                    </Button>
                                  )
                                )}
                              </ButtonGroup>
                            </div>
                            <div>
                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          ) : (
            <ToolkitProvider
              keyField="id"
              data={filteredTableData}
              columns={columns}
            >
              {(props) => (
                <Row>
                  <Col md="12">
                    <BootstrapTable
                      {...props.baseProps}
                      keyField={keyField}
                      loading={isLoading}
                      filter={filterFactory()}
                      bordered={false}
                      hover={!!(!isLoading && filteredTableData?.length)}
                      bootstrap4
                      sort={{
                        dataField: "name",
                        order: "asc",
                      }}
                      noDataIndication={
                        isError ? (
                          <GeneralError />
                        ) : isLoading ? (
                          <Spinner />
                        ) : (
                          <div className="no-data">
                            {language["GENERAL.NO_DATA"]}
                          </div>
                        )
                      }
                    />
                  </Col>
                </Row>
              )}
            </ToolkitProvider>
          )}
        </Col>
      </Row>
    </div>
  );
}
